import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import CustomSelect from "../Common/CustomSelect";
import { FaProjectDiagram, FaPuzzlePiece, FaBox } from "react-icons/fa";
import { getCurrentTenant, setCurrentTenant } from "../../hooks/useCurrentTenant";
import "./Home.css";

export default function Home() {
    const navigate = useNavigate();
    const { keycloak } = useKeycloak();

    const username =
        keycloak?.tokenParsed?.given_name ||
        keycloak?.tokenParsed?.name ||
        "User";

    const tenants = keycloak?.tokenParsed?.groups || [];
    const [currentTenant, setCurrentTenantState] = useState(
        getCurrentTenant() ||
        (tenants[0] ? tenants[0].replace("/", "") : "")
    );

    useEffect(() => {
        if (!getCurrentTenant() && tenants.length > 0) {
            const tenant = tenants[0].replace("/", "");
            setCurrentTenant(tenant);
            setCurrentTenantState(tenant);
        }
    }, [tenants]);

    return (
        <div className="home-wrapper">
            {/* Greeting */}
            <div className="home-header">
                <h1 className="home-title">
                    Hello {username}!
                </h1>
                <div className="company-selector">
                    <span className="company-label">Company:</span>

                    <CustomSelect
                        value={currentTenant}
                        onChange={(val) => {
                            const tenant = val.replace("/", "");
                            setCurrentTenantState(tenant);
                            setCurrentTenant(tenant);
                        }}
                        options={tenants.map((tenant) => {
                            const cleanTenant = tenant.replace("/", "");
                            return {
                                value: cleanTenant,
                                label: cleanTenant,
                            };
                        })}
                    />

                </div>

            </div>

            <hr className="home-divider" />

            {/* Section */}
            <div className="home-section">
                <h2 className="home-section-title">Layout apps</h2>
                <p className="home-section-subtitle">
                    Build and configure panel layouts with integrated scenarios and parts.
                </p>

                <div className="home-apps-grid">
                    <HomeCard
                        title="Projects"
                        description="Manage projects"
                        icon={<FaProjectDiagram />}
                        onClick={() => navigate("/projects")}
                    />

                    <HomeCard
                        title="Scenarios"
                        description="Manage scenarios"
                        icon={<FaPuzzlePiece />}
                        onClick={() => navigate("/scenarios")}
                    />
                    <HomeCard
                        title="Parts"
                        description="Manage parts"
                        icon={<FaBox />}
                        onClick={() => navigate("/partslibrary")}
                    />

                    <HomeCard
                        className="global-parts-child"
                        title="Global parts"
                        description={
                            currentTenant === "Innovation_Projects"
                                ? "Manage Parts"
                                : "Browse global parts"
                        }
                        icon={<FaBox />}
                        onClick={() => navigate("/globallibrary")}
                    />
                </div>
            </div>
        </div>
    );
}

function HomeCard({ title, description, icon, onClick, disabled, className = "", }) {
    return (
        <button
            className={`home-card ${className} ${disabled ? "is-disabled" : ""}`}
            onClick={!disabled ? onClick : undefined}
            disabled={disabled}
        >
            <div className="home-card-icon">{icon}</div>

            <div className="home-card-content">
                <h3>{title}</h3>
                <p>{description}</p>
            </div>
        </button>
    );
}